<template>
  <div id="printBarCode" style="text-align: center">
    <div v-show="false">
      <div class="qrCode-page" id="qrCodePrint">
        <div v-for="item in barcodeList" >
          <div v-for="index in printCount" v-bind:key="index" class="bracodeheader" >
            <Row>
              <Col span="15">
                <div class="bracodeheader-count" :style="{'font-size':'13px','margin-bottom':(!item.idCard?'5px':'')}">
                  <span style="font-size: 12px">{{item.name?item.name:""}}</span>&nbsp;
                  <span>{{item.gender===1?"男":item.gender===2?"女":""}}</span>&nbsp;
                  <span>{{item.age ? item.age + "岁" : ""}}</span>
                </div>
                <div class="bracodeheader-idCard" :style="{'font-size':'14px','margin-top':(item.idCard?'-3px':'')}">{{item.idCard?item.idCard:""}}</div>
                <barcode :value="item.barCode" height="60" width="2" displayValue="false" marginTop="-5" marginLeft="20" margin-right="40" v-if="!item.barCodeImage">条形码加载失败</barcode>
                <div style="text-align:center;margin-top:-8px;margin-left:15px;width: 115px; height: 35px;" v-if="item.barCodeImage">
                  <img :src="item.barCodeImage" style="width: 100%; height: 100%;"/>
                </div>
<!--                <div class="bracodeheader-pid" style="font-size: 15px">{{item.barCode?item.barCode:""}}</div>-->
              </Col>
              <Col span="2"/>
              <Col span="7">
                <div class="bracodeheader-count" style="font-size:12px;margin-left:0px;margin-right: 2px;">抽血试管</div>
                <div class="bracodeheader-count" style="font-size:12px;margin-left:0px;margin-top:0px;word-break: break-all;line-height: 15px;text-align:left;width: 100%;"
                     v-for="testTube in item.testTubes.split('、')" v-if="item.testTubes">{{ testTube }}</div>
              </Col>
            </Row>
            <span :style="{'position':'relative','font-size':'15px','float':'left','padding-left':'20px','margin-top':'-3px'}">{{item.barCode?item.barCode:""}}{{item.serNum? '&nbsp;&nbsp;&nbsp;&nbsp;' + item.serNum:""}}</span>
            <span class="bracodeheader-class" style="font-size: 12px">{{item.gradeName?item.gradeName:""}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.className?item.className:""}}</span>
          </div>
        </div>
      </div>
    </div>
    <a id="printBarcode" v-print="printQrCodeContent" v-show="false">打印</a>
  </div>
</template>
<script>
import {_batchPrintBarcode} from "@/services/screening/screeningDatainfo";
export default {
  name: "PrintBarCode",
  props: {
    printCount: {
      type: Number,
      default: () => {
        return 1
      }
    },
  },
  data() {
    return {
      showPrintBarCode:false,
      barcode:{
        barCode: "",
        gradeName: "",
        className: "",
        name: "",
        idCard: "",
        age: "",
        gender: "",
        packagesName: "",
        testTubes: "",
      },
      barcodeOptions:{
        height: "60",
        width: "2",
        displayValue: false,
        marginTop: "3",
        marginLeft: "3"
      },
      barcodeList:[],
      printQrCodeContent:{
        id:"qrCodePrint",
        preview:false,
        previewTitle:'  ',
        popTitle:'  ',
        extraHead:'<meta http-equiv="Content-Language" content="zh-cn"/>',
        previewBeforeOpenCallback(){

        },
        previewOpenCallback(){

        },
        beforeOpenCallback(vue){
          vue.printLoading=true

        },
        openCallback(vue){
          vue.printLoading=false

        },
        closeCallback(){
          this.showPrintBarCode = false;
        },
        clickMounted(vue){
          // vue.printQrCodeContent.popTitle="      "
        }
      },
      init: "",
      loading: {
        form: false,
        btn: false
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    batchPrintBarcode(param){
      this.barcodeList = [];
      _batchPrintBarcode(param).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          this.barcodeList = res.data;
        }else{
          this.$Message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    print(){
      this.$nextTick(()=>{
        this.showPrintBarCode = false;
        document.getElementById('printBarcode').click();
      })
    },
    handleModal(param, isshow) {
      this.isshow = !!isshow;
      this.batchPrintBarcode(param);
    },
  }
};
</script>
<style lang="postcss" scoped>
@media print {
  .qrCode-page {
    page: qrCode-page; /* 绑定唯一命名 */
  }
  @page qrCode-page{
    size:5cm 3cm;
    margin: 0;
    padding: 0;
    zoom: 100%;
  }
}
.bracodeheader{
  color:#000000;
  max-width:270px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  page-break-after:always;
  //margin-left:15px;
  //text-align: center;
}
.bracodeheader-count{
  position: relative;
  margin-top:2px;
  z-index:2;
  font-size:18px;
  line-height:24px;
  text-align: center;
  margin-left:11px;
}
.bracodeheader-count span{
  text-align: center
}
.bracodeheader-idCard{
  position: relative;
  top:-5px;
  z-index:2;
  font-size:18px;
  line-height:24px;
  text-align: center;
  margin-left:12px;
}
.bracodeheader-pid{
  position: relative;
  top:-3px;
  z-index:10;
  line-height:22px;
  font-size:21px;
  text-align:center;
  margin-left:20px;
}
.bracodeheader-class{
  position: relative;
  top:-5px;
  z-index:10;
  line-height:14px;
  font-size:17px;
  float: left;
  padding-left: 20px;
}

</style>
